/**
 * Dev-only counters for camera saga emits vs spring retargets.
 * Inspect in console: window.__cameraDebug()
 */

import { env } from '~/app/env';

let sagaEmitCount = 0;
let sagaSkipCount = 0;
let springRetargetCount = 0;

export function recordCameraSagaEmit(): void {
  if (!env.dev) return;
  sagaEmitCount += 1;
}

export function recordCameraSagaSkipped(): void {
  if (!env.dev) return;
  sagaSkipCount += 1;
}

export function recordCameraSpringRetarget(): void {
  if (!env.dev) return;
  springRetargetCount += 1;
}

export function getCameraDebugStats(): {
  sagaEmitCount: number;
  sagaSkipCount: number;
  springRetargetCount: number;
} {
  return { sagaEmitCount, sagaSkipCount, springRetargetCount };
}

export function resetCameraDebugStats(): void {
  sagaEmitCount = 0;
  sagaSkipCount = 0;
  springRetargetCount = 0;
}

declare global {
  interface Window {
    __cameraDebug?: typeof getCameraDebugStats;
    __cameraDebugReset?: typeof resetCameraDebugStats;
  }
}

if (env.dev && typeof window !== 'undefined') {
  window.__cameraDebug = getCameraDebugStats;
  window.__cameraDebugReset = resetCameraDebugStats;
}
